export default "__VITE_PUBLIC_ASSET__2f552240__"